import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import bookingActions from 'actions/bookings/actions'
import Table from 'components/shared/table/table'
import THead from 'components/shared/table/table-header'
import TBody from 'components/shared/table/table-body'
import TRow from 'components/shared/table/table-row'
import TCol from 'components/shared/table/table-column'
import Instruction from 'components/shared/instructions/booking'
import ColStatus from '../col-status'
import { toPayInstruction } from '../dataset'

const ToPayList = ({ headers, list, fetchToPay, handleSwitchContent }) => {
  useEffect(() => { fetchToPay() }, [])

  return (
    <div className="client-requests-list">
      <div className="mt-5">
        <Instruction instructions={toPayInstruction} />
        <div className="overflow-auto">
          <Table classes="w-full border-collapse">
            <THead classes="text-xs bg-lightgray font-semibold">
              {headers.map((header, key) => (
                <TCol classes="p-3" key={key} align={header.align || 'left'}>
                  {header.name}
                </TCol>
              ))}
            </THead>
            <TBody>
              {list.map(item => (
                <TRow classes="border-t text-sm hover:bg-gray-100" key={item.id} >
                  <TCol classes="p-3">{item.createDate}</TCol>
                  <TCol classes="p-3">{item.requestDate}</TCol>
                  <TCol classes="p-3 text-primary-orange">
                    <a href={item.spaceLink}>{item.space}</a>
                  </TCol>
                  <TCol classes="p-3">{item.amount}</TCol>
                  <ColStatus classes="p-3 font-semibold text-xs" status={item.status} />
                  <TCol classes="p-3" align="right">
                    <ul className="flex items-center flex-row font-semibold justify-end text-center text-primary-orange">
                      <li onClick={() => handleSwitchContent({ value: 'view-proposal', proposalId: item.id })} className="mx-1 cursor-pointer">
                        View Proposal
                      </li>
                      <li className="mx-1">
                        <Link to={`/client/messages/${item.conversation_id}/conversation`} target="_blank">Message</Link>
                      </li>
                      <li className="mx-1">
                        <Link to={`/client/transaction/pay/${item.id}`}>Pay Now</Link>
                      </li>
                    </ul>
                  </TCol>
                </TRow>
              ))}
            </TBody>
          </Table>
        </div>
      </div>
    </div>
  )
}

ToPayList.propTypes = {
  headers: PropTypes.array.isRequired,
  fetchToPay: PropTypes.func.isRequired,
  list: PropTypes.array,
  handleSwitchContent: PropTypes.func.isRequired,
}

const mapStateToProps = ({ bookings }) => ({
  headers: bookings.client.toPay.headers,
  list: bookings.client.toPay.list,
})

const mapDispatchToProps = {
  fetchToPay: bookingActions.fetchClientToPay,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ToPayList)
